// Búsqueda por términos del lado del cliente.
//
// Misma semántica que la del backend (`buildSearchWhere` en el repo del backend), para que el
// operador no tenga que aprender dos buscadores distintos según la pantalla:
//
//     matchea si (algún campo contiene la frase entera)  O  (cada palabra está en ALGÚN campo)
//
// La rama de palabras es la que hace que "juan perez" encuentre a la persona aunque el nombre
// viva en una columna y el apellido en otra. Exige TODAS las palabras, así que escribir más
// siempre acota: nunca trae más ruido.
//
// Se descartan los diacríticos de los dos lados —la ñ incluida, a propósito— para que "peres"
// no dependa de cómo se tecleó el acento y los resultados no cambien el día que esta búsqueda
// se mueva al servidor, donde la collation de MySQL ya ignora las tildes.
export function normalizeForSearch(value) {
    return String(value == null ? '' : value)
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim();
}

export function splitSearchTerms(search, maxTerms = 6) {
    return normalizeForSearch(search)
        .split(/\s+/)
        .filter((term) => term.length > 0)
        .slice(0, maxTerms);
}

// `fields` son los valores de la fila que el operador VE en la grilla. Matchear un campo que no
// está en pantalla hace que el buscador parezca roto: devuelve filas donde no se ve por qué.
export function matchesSearchTerms(fields, search) {
    const frase = normalizeForSearch(search);
    if (!frase) {
        return true;
    }

    const valores = (Array.isArray(fields) ? fields : [fields])
        .map(normalizeForSearch)
        .filter((valor) => valor.length > 0);

    if (valores.some((valor) => valor.includes(frase))) {
        return true;
    }

    const terminos = splitSearchTerms(search);
    if (terminos.length < 2) {
        return false;
    }
    return terminos.every((termino) => valores.some((valor) => valor.includes(termino)));
}
